(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funnel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('triade-funnel')) {
    customElements.define('triade-funnel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const select = this.querySelector('[data-variants]');
        if (!select) return;
        const update = () => {
          const option = select.selectedOptions[0];
          if (!option) return;
          this.querySelector('[data-price]').textContent = option.dataset.price;
          const compare = this.querySelector('[data-compare]');
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
          const button = this.querySelector('[data-submit]');
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
          const gallery = this.querySelector('.funnel__gallery');
          const slide = Array.from(gallery.querySelectorAll('[data-image-id]')).find(item => item.dataset.imageId === option.dataset.image);
          if (slide) gallery.scrollLeft = slide.offsetLeft - gallery.firstElementChild.offsetLeft;
        };
        select.addEventListener('change', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
